// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25Scp","fullView":"styles_fullView__3zV4a"};